export default function siteSearch() {
	function cleanBackslashes(value) {
		if (!value) {
			return value;
		}

		let cleaned = value;
		const maxIterations = 20;
		let iterations = 0;

		// Remove excessive double backslashes
		while (cleaned.indexOf('\\\\') !== -1 && iterations < maxIterations) {
			cleaned = cleaned.replace(/\\\\/g, '\\');
			iterations ++;
		}

		// Remove backslashes before quotes
		cleaned = cleaned.replace(/\\'/g, "'").replace(/\\"/g, '"');

		return cleaned;
	}

	/**
	 * ============================
	 * HEADER POPOVER MODULE
	 * ============================
	 */
	(function headerPopover() {
		const popover = document.querySelector('.site-header__search-popover');
		const toggle = document.querySelector('.site-header__search-button');
		const form = document.querySelector('.site-header__search-form');
		const input = document.querySelector('#site-header-search-input') || document.querySelector('.site-header__search-input');
		const popular = document.querySelector('.site-header__search-popover [data-popular-searches]');

		if (!popover || !toggle || !form || !input) {
			return;
		}

		// Clean input value on load
		if (input.value) {
			input.value = cleanBackslashes(input.value);
		}

		// Ensure an initial hidden state (so our first "open" always works)
		if (!popover.hasAttribute('inert')) {
			popover.setAttribute('inert', '');
		}

		const open = () => {
			popover.removeAttribute('inert');
			popover.classList.add('is-open');
			toggle.classList.add('is-active');
			// defer focus so CSS transition doesn't steal it
			setTimeout(() => input.focus(), 0);
		};

		const close = () => {
			popover.setAttribute('inert', '');
			popover.classList.remove('is-open');
			toggle.classList.remove('is-active');
		};

		const isOpen = () => !popover.hasAttribute('inert');

		// Click toggle
		toggle.addEventListener('click', (e) => {
			e.preventDefault(); // avoid any default navigation/submit
			e.stopPropagation(); // don't let document click close it immediately
			isOpen() ? close() : open();
		});

		// Keyboard activate (Enter/Space)
		toggle.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				isOpen() ? close() : open();
			}
		});

		// Esc to close
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && isOpen()) {
				close();
			}
		});

		// Click outside to close (but ignore clicks on the toggle or inside popover)
		document.addEventListener('click', (e) => {
			if (!isOpen()) {
				return;
			}
			const t = e.target;
			if (popover.contains(t) || toggle.contains(t)) {
				return;
			}
			close();
		});

		// Popular searches → fill input + submit
		if (popular) {
			popular.addEventListener('click', (e) => {
				const btn = e.target.closest('[data-popular]');
				if (!btn) {
					return;
				}
				const q = btn.getAttribute('data-popular') || '';
				input.value = q;
				form.submit();
			});
		}

		// Clean input before form submission
		form.addEventListener('submit', (e) => {
			if (input.value) {
				input.value = cleanBackslashes(input.value);
			}
		});

		// Prevent header form from doing anything weird if the submit button is an actual <button>
		const submitBtn = form.querySelector('[type="submit"]');
		if (submitBtn) {
			submitBtn.addEventListener('click', (e) => {
				// If the input is empty, just focus it instead of submitting a blank search
				if (!input.value.trim()) {
					e.preventDefault();
					input.focus();
				}
			});
		}
	}());

	/**
	 * ============================
	 * SEARCH PAGE MODULE
	 * ============================
	 */
	const root = document.querySelector('[data-site-search]');
	if (!root) {
		// Header popover is already wired above; nothing else to do.
		return;
	}

	// ---------- config ----------
	const endpoint = root.getAttribute('data-endpoint') || '/wp-json/olt/v1/search';
	const DEFAULT_TYPE = (root.getAttribute('data-default-type') || 'shows').toLowerCase();
	// ---------- hooks ----------
	const form = root.querySelector('[data-search-form]');
	const input = root.querySelector('[data-search-input]');
	const submitBtn = root.querySelector('[data-search-submit]');
	const tabsNav = root.querySelector('[data-search-tabs]');
	const resultsEl = root.querySelector('[data-search-results]');
	const moreBtn = root.querySelector('[data-search-more]');
	const countEl = root.querySelector('[data-search-count]');
	const headingEl = root.querySelector('[data-search-heading]');
	const popularEl = root.querySelector('[data-popular-searches]');
	const includeFinishedCheckbox = root.querySelector('[data-include-finished]');

	if (!form || !input || !tabsNav || !resultsEl) {
		return;
	}

	// Clean input value on page load
	if (input.value) {
		input.value = cleanBackslashes(input.value);
	}

	const DEFAULT_PER_PAGE = Math.max(1, parseInt(root.getAttribute('data-per-page') || '24', 10));

	// Minimum characters before a search request is issued. Tunable from the template via
	// data-min-chars (an explicit 0 disables the guard); 3 by default.
	//
	// Parsed defensively: parseInt('abc') is NaN, and every `length < NaN` comparison is
	// false, so a typo in the attribute would silently disable the guard rather than fail
	// loudly. Fall back to the default instead.
	const parsedMinChars = parseInt(root.getAttribute('data-min-chars') ?? '', 10);
	const MIN_CHARS = Number.isInteger(parsedMinChars) ? Math.max(0, parsedMinChars) : 3;

	// ---------- state ----------
	const state = {
		q: '',
		type: DEFAULT_TYPE, // 'all' | 'shows' | 'news' | 'venues'
		page: 1,
		perPage: DEFAULT_PER_PAGE,
		total: 0,
		items: [],
		loading: false,
		controller: null,
		includeFinished: false
	};

	// ---------- utils ----------
	const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

	function debounce(fn, wait = 300) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn(...args), wait);
		};
	}

	function setAriaBusy(on) {
		resultsEl.setAttribute('aria-busy', on ? 'true' : 'false');
		if (submitBtn) {
			submitBtn.disabled = !!on;
		}
		if (moreBtn) {
			moreBtn.disabled = !!on;
		}
	}

	function updateHeading() {
		const map = { all: 'All Results', shows: 'Shows', news: 'News', venues: 'Venues' };
		if (headingEl) {
			headingEl.textContent = map[ state.type ] || 'Results';
		}
	}

	function pillLabel(type) {
		switch (type) {
			case 'show': return 'Show';
			case 'venue': return 'Venue';
			case 'news': return 'News';
			default: return '';
		}
	}

	function adaptResponse(json) {
		const items = Array.isArray(json.items) ? json.items : [];
		return {
			total: typeof json.total === 'number' ? json.total : items.length,
			page: typeof json.page === 'number' ? json.page : state.page,
			perPage: typeof json.perPage === 'number' ? json.perPage : state.perPage,
			items: items.map((it) => ({
				id: it.id,
				type: (it.type || '').toLowerCase(), // show | venue | news
				title: String(it.title || ''),
				url: String(it.url || '#'),
				image: String(it.image || ''),
				label: String(it.label || pillLabel(it.type)),
				minPrice: typeof it.minPrice === 'number' ? it.minPrice : null,
				currency: it.currency || '£',
				meta: it.meta || ''
			}))
		};
	}

	function cardTemplate(it) {
		const img = it.image ? `<img loading="lazy" decoding="async" src="${ escapeAttr(it.image) }" alt="${ escapeAttr(it.title) }" />` : '';
		const badge = it.label ? `<span class="site-search-card__badge site-grid__items-card-badge">${ escapeHtml(it.label) }</span>` : '';
		return `
      <article class="site-search-card site-grid__items-card" data-type="${ escapeAttr(it.type) }">
        <a class="site-search-card__link site-grid__items-card-link" href="${ escapeAttr(it.url) }" aria-label="${ escapeAttr(it.title) }">
          <figure class="site-search-card__image site-grid__items-card-image">${ img }</figure>
          <div class="site-search-card__details site-grid__items-card-details">
			${ badge }
            <h3 class="site-search-card__title site-grid__items-card-details-title">${ it.title }</h3>
          </div>
        </a>
      </article>
    `;
	}

	function escapeHtml(s) {
		return String(s)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}
	function escapeAttr(s) {
		return escapeHtml(s).replace(/"/g, '&quot;');
	}

	function emptyTemplate() {
		const q = state.q.trim();
		return `
      <div class="site-search__empty">
        <p>No results ${ q ? `for "${ escapeHtml(q) }"` : '' } in ${ escapeHtml(headingEl?.textContent || 'Results') }.</p>
        ${ popularEl ? '<p>Try a popular search:</p>' : '' }
      </div>
    `;
	}

	/**
	 * Whether the current query is too short to search on.
	 *
	 * A 1-2 character query matches almost everything, and the server-side search filter
	 * routes tokens of 2 characters or fewer through a REGEXP over post_content — the most
	 * expensive path there is. Suppressing those avoids a request per keystroke.
	 *
	 * An empty query is deliberately NOT treated as too short: that is the page's initial
	 * "browse this tab" state, which is left behaving as it did.
	 */
	function queryTooShort() {
		const q = state.q.trim();
		return q.length > 0 && q.length < MIN_CHARS;
	}

	function tooShortTemplate() {
		return `
      <div class="site-search__empty site-search__too-short">
        <p>Please enter at least ${ MIN_CHARS } characters to search.</p>
      </div>
    `;
	}

	function normaliseType(raw) {
		const r = String(raw || '').toLowerCase();
		if (r === 'venue') {
			return 'venues';
		}
		if (r === 'show') {
			return 'shows';
		}
		if (r === 'news' || r === 'posts') {
			return 'news';
		}
		return ['all', 'shows', 'news', 'venues'].includes(r) ? r : 'shows';
	}

	function setURLFromState(replace = false) {
		const url = new URL(location.href);

		if (state.q) {
			url.searchParams.set('s', state.q);
		} else {
			url.searchParams.delete('s');
		}

		const type = normaliseType(state.type);
		if (type && type !== 'all') {
			url.searchParams.set('type', type);
		} else {
			url.searchParams.delete('type');
		}

		if (state.page && state.page > 1) {
			url.searchParams.set('page', String(state.page));
		} else {
			url.searchParams.delete('page');
		}

		if (state.includeFinished) {
			url.searchParams.set('includeFinished', '1');
		} else {
			url.searchParams.delete('includeFinished');
		}

		(replace ? history.replaceState : history.pushState).call(history, null, '', url.toString());
	}

	function restoreStateFromURL() {
		const url = new URL(location.href);
		const q = url.searchParams.get('s') ?? '';
		const urlTypeRaw = url.searchParams.get('type');
		const type = urlTypeRaw ? normaliseType(urlTypeRaw) : DEFAULT_TYPE;
		const page = Math.max(1, parseInt(url.searchParams.get('page') || '1', 10));
		const includeFinished = url.searchParams.get('includeFinished') === '1';

		// Clean backslashes from URL parameter
		state.q = cleanBackslashes(q);
		state.type = type;
		state.page = page;
		state.includeFinished = includeFinished;

		input.value = state.q;
		selectTab(type);
		updateHeading();

		if (includeFinishedCheckbox) {
			includeFinishedCheckbox.checked = includeFinished;
		}
	}

	function selectTab(type) {
		$$(('[role="tab"]'), tabsNav).forEach((btn) => {
			const isActive = (btn.getAttribute('data-tab') || '').toLowerCase() === type;
			btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
			btn.tabIndex = isActive ? 0 : -1;
		});

		// Show/hide the "Include closed shows" checkbox based on tab
		if (includeFinishedCheckbox) {
			const container = includeFinishedCheckbox.closest('.site-search__head-options');
			const shouldShow = type === 'shows' || type === 'all';
			if (container) {
				container.style.display = shouldShow ? '' : 'none';
			}
		}
	}

	function updateCount() {
		if (!countEl) {
			return;
		}
		const total = state.total || 0;
		countEl.textContent = total > 0 ? `${ total } result${ total === 1 ? '' : 's' }` : '';
	}

	function toggleMoreButton() {
		const canMore = state.items.length < state.total;
		if (moreBtn) {
			moreBtn.hidden = !canMore;
		}
	}

	function setLoading(on) {
		state.loading = !!on;
		setAriaBusy(on);
		root.classList.toggle('is-loading', !!on);
	}

	function clearResults() {
		state.items = [];
		state.total = 0;
		resultsEl.innerHTML = '';
		updateCount();
		toggleMoreButton();
	}

	// ---------- rendering ----------
	function renderAppend(items) {
		const html = items.map(cardTemplate).join('');
		const wrapper = document.createElement('div');
		wrapper.innerHTML = html;
		resultsEl.append(...wrapper.children);
	}

	function renderInitial(items) {
		resultsEl.innerHTML = items.length ? items.map(cardTemplate).join('') : emptyTemplate();
	}

	// ---------- fetch ----------
	async function fetchResults({ append = false } = {}) {
		if (state.controller) {
			state.controller.abort();
		}

		// Guarded here rather than at each call site so every entry point is covered:
		// typing, tab switches, popular searches, load more, back/forward, the
		// includeFinished toggle, and first paint.
		if (queryTooShort()) {
			state.controller = null;
			clearResults();
			resultsEl.innerHTML = tooShortTemplate();
			setLoading(false);
			return;
		}

		state.controller = new AbortController();

		setLoading(true);
		try {
			const params = new URLSearchParams();
			params.set('q', state.q);
			params.set('type', state.type);
			params.set('page', String(state.page));
			params.set('perPage', String(state.perPage));
			params.set('includeFinished', state.includeFinished ? 'true' : 'false');

			const url = `${ endpoint }?${ params.toString() }`;
			const res = await fetch(url, { signal: state.controller.signal, credentials: 'same-origin' });
			if (!res.ok) {
				throw new Error(`Search failed (${ res.status })`);
			}
			const data = adaptResponse(await res.json());

			state.total = data.total;
			if (append) {
				state.items = state.items.concat(data.items);
				renderAppend(data.items);
			} else {
				state.items = data.items;
				renderInitial(data.items);
			}
			updateCount();
			toggleMoreButton();
		} catch (err) {
			if (err.name !== 'AbortError') {
				if (!append) {
					resultsEl.innerHTML = `<div class="site-search__error" role="alert"><p>Sorry, something went wrong fetching results.</p></div>`;
					state.items = [];
					state.total = 0;
					updateCount();
					toggleMoreButton();
				}
			}
		} finally {
			setLoading(false);
		}
	}

	// ---------- events ----------
	const doSearch = debounce(() => {
		state.page = 1;
		setURLFromState();
		fetchResults({ append: false });
	}, 300);

	// Prevent duplicate submissions
	let isSubmitting = false;

	form.addEventListener('submit', (e) => {
		// Prevent rapid resubmission
		if (isSubmitting) {
			e.preventDefault();
			return;
		}

		const q = (input.value || '').trim();
		if (!q) {
			return;
		}

		// Clean input before navigation
		input.value = cleanBackslashes(input.value);

		e.preventDefault();
		const action = form.getAttribute('action') || '/';
		const url = new URL(action, location.origin);
		url.searchParams.set('s', input.value);
		url.searchParams.set('type', 'shows');

		isSubmitting = true;
		location.href = url.toString();

		// Reset flag after navigation starts
		setTimeout(() => {
			isSubmitting = false;
		}, 1000);
	});

	input.addEventListener('input', () => {
		state.q = cleanBackslashes((input.value || '').trim());
		doSearch();
	});

	input.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && input.value) {
			input.value = '';
			state.q = '';
			doSearch();
		}
	});

	// Tabs
	tabsNav.addEventListener('click', (e) => {
		const btn = e.target.closest('[role="tab"][data-tab]');
		if (!btn) {
			return;
		}
		e.preventDefault();
		const type = (btn.getAttribute('data-tab') || 'all').toLowerCase();
		if (type === state.type) {
			return;
		}
		state.type = type;
		selectTab(type);
		updateHeading();
		state.page = 1;
		clearResults();
		setURLFromState();
		fetchResults({ append: false });
	});

	// Tabs: Arrow key roving focus
	tabsNav.addEventListener('keydown', (e) => {
		const tabs = $$(('[role="tab"]'), tabsNav);
		const idx = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
		if (idx < 0) {
			return;
		}

		let next = idx;
		if (e.key === 'ArrowRight') {
			next = (idx + 1) % tabs.length;
		} else if (e.key === 'ArrowLeft') {
			next = (idx - 1 + tabs.length) % tabs.length;
		} else {
			return;
		}

		e.preventDefault();
		tabs[ next ].focus();
		tabs[ next ].click();
	});

	// Popular searches (on the search page)
	if (popularEl) {
		popularEl.addEventListener('click', (e) => {
			const b = e.target.closest('[data-popular]');
			if (!b) {
				return;
			}
			e.preventDefault();
			const q = b.getAttribute('data-popular') || '';
			input.value = q;
			state.q = q;
			state.page = 1;
			setURLFromState();
			fetchResults({ append: false });
			input.focus();
		});
	}

	// Load more
	if (moreBtn) {
		moreBtn.addEventListener('click', (e) => {
			e.preventDefault();
			if (state.loading) {
				return;
			}
			const canMore = state.items.length < state.total;
			if (!canMore) {
				return;
			}
			state.page += 1;
			setURLFromState();
			fetchResults({ append: true });
		});
	}

	// Handle back/forward
	window.addEventListener('popstate', () => {
		restoreStateFromURL();
		clearResults();
		fetchResults({ append: false });
	});

	// Include finished shows checkbox
	if (includeFinishedCheckbox) {
		includeFinishedCheckbox.addEventListener('change', (e) => {
			state.includeFinished = e.target.checked;
			state.page = 1;
			clearResults();
			setURLFromState();
			fetchResults({ append: false });
		});
	}

	// ---------- init ----------
	function initTabsA11y() {
		$$(('[data-search-tabs] [data-tab]'), tabsNav).forEach((btn, i) => {
			btn.setAttribute('role', 'tab');
			if (!btn.hasAttribute('aria-selected')) {
				btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
			}
			if (!btn.hasAttribute('tabindex')) {
				btn.tabIndex = i === 0 ? 0 : -1;
			}
		});
		tabsNav.setAttribute('role', 'tablist');
		tabsNav.setAttribute('aria-label', tabsNav.getAttribute('aria-label') || 'Result types');
	}

	initTabsA11y();
	restoreStateFromURL();
	setURLFromState(true);
	clearResults();
	fetchResults({ append: false });
}
